<template>
  <SmallSquare content="1、积分获取路径有参与扫码营销、参与互动营销、任务奖励、默认积分、会员礼包等
2、积分可用于积分商城兑换、消耗积分参与活动" />

  <a-form ref='form' :model='ruleForm' :initialValues="search" :onFinish='pageSearchChange' :colon='false' class='m-t-35'>
    <a-form-item label="" name='' :wrapper-col="{ span: 20,offset:1}" >
      <div class="s_flex_ali">
        <p class="m-r-10 s_font_b fz-15 s_c000" >自定义积分名称</p>
        <a-input v-model:value="dataMore.custom_name" style="width:20%;" placeholder='请输入积分别名' maxlength="2"/>
        <p class="s_c999">（自定义积分名称仅对前端生效，为空则前端显示为“积分”，后台统一定义为“积分”。）</p>
      </div>
    </a-form-item>



    <a-form-item :wrapper-col="{ span: 4,offset:1}" class='m-t-25'>
      <a-button type="primary" v-has:pointSetUp="onSubmit">
        保存设置
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
 import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { ref, onMounted, inject, reactive, toRefs } from 'vue';
import { setPoint, getPoint } from '@/api/assets';
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
import { isArray } from 'lodash';
export default {
  name: 'integralSet',
  components:{},
  setup() {
    const state = reactive({
      dataMore: {
        obtain_point: 1,
        consume_point:1,
        consume_percentage:1,
        is_give_point_group:0,
        is_deduction_money_group:0,
        is_give_point_seckill:0,
        is_deduction_money_seckill:0,
        is_offline_write_off:0,
        another_name:'积分',
        is_deduction_money_treasure:0,
        is_give_point_treasure:0,
        custom_name:'积分'
      },
    });
    const onSubmit = async () => {
      let res = await setPoint(state.dataMore ).then(
        (res) => res.data
      );
      if (iscode(res)) {
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }
    };
    const initData = async () => {
      let res = await getPoint().then((res) => res.data);
      if (iscode(res)) {
        console.log(res,res.data.values)
        if(!isArray(res.data)){
          state.dataMore = res.data.values;
        }
      } else {
        message.error(res.msg);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      onSubmit,
    };
  },
};
</script>